import { useAPIClient } from '@src/api';
import { useBaseMutation } from '@src/corelib/query';
import type { BaseMutationOptions } from '@src/corelib/query/useBaseMutation';

function useMutation<
  TData = unknown,
  TError = Error,
  TVariables = void,
  TContext = unknown,
>(params: BaseMutationOptions<TData, TError, TVariables, TContext>) {
  const apiClient = useAPIClient();
  return useBaseMutation<TData, TError, TVariables, TContext>(apiClient, params);
}

export default useMutation;
